const CANONICAL_DECIMAL = /^(-?)(\d+)(?:\.(\d{1,2}))?$/;
const MAX_INTEGER_DIGITS = 16;
const THOUSANDS_GROUP = /\B(?=(\d{3})+(?!\d))/g;

/**
 * Formata string decimal canônica como moeda pt-BR (ex.: `1234.5` → `R$ 1.234,50`).
 * Opera só sobre a string: valores monetários nunca passam por `number`.
 */
export function formatMoney(amount: string, currency = 'BRL'): string {
  const match = CANONICAL_DECIMAL.exec(amount);
  if (!match) return amount;
  const [, sign = '', rawInteger = '', rawFraction = ''] = match;
  const integer = (rawInteger.replace(/^0+(?=\d)/, '') || '0').replace(THOUSANDS_GROUP, '.');
  const fraction = rawFraction.padEnd(2, '0');
  const isZero = /^[0.]+$/.test(integer) && fraction === '00';
  const symbol = currency === 'BRL' ? 'R$' : currency;
  return `${isZero ? '' : sign}${symbol} ${integer},${fraction}`;
}

/**
 * Converte texto digitado em pt-BR (`1.234,56`, `R$ 10`) para decimal canônico (`1234.56`).
 * Rejeita mais de 2 casas e mais de 16 dígitos inteiros em vez de arredondar.
 */
export function parseLocalizedMoney(input: string): string | null {
  const cleaned = input.replace(/R\$/g, '').replace(/\s/g, '');
  const match = /^(-?)((?:\d{1,3}(?:\.\d{3})+)|\d+)(?:,(\d{1,2}))?$/.exec(cleaned);
  if (!match) return null;
  const [, sign = '', rawInteger = '', rawFraction = ''] = match;
  const integer = rawInteger.replace(/\./g, '').replace(/^0+(?=\d)/, '');
  if (integer.length > MAX_INTEGER_DIGITS) return null;
  const fraction = rawFraction.padEnd(2, '0');
  const isZero = /^0+$/.test(integer) && fraction === '00';
  return `${isZero ? '' : sign}${integer}.${fraction}`;
}
